import React, {useEffect, useState} from 'react'
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AtlasChart from "./AtlasChart";
import {widgetResponse200EMA, widgetResponse50EMA} from "./data";

const trendTimes = [
  1616697000000,
  1617042600000,
  1617129000000,
  1617215400000,
  1617561000000,
  1617647400000,
  1617733800000,
  1617820200000,
  1617906600000,
  1618165800000,
  1618252200000,
  1618425000000,
  1618511400000,
  1618770600000,
  1618857000000,
  1619029800000,
  1619116200000,
  1619375400000,
  1619461800000,
  1619548200000,
  1619634600000,
  1619721000000,
  1619980200000,
  1620066600000,
  1620153000000,
  1620239400000,
  1620325800000,
  1620585000000,
  1620671400000,
  1620757800000,
  1620930600000,
  1621189800000,
  1621276200000,
  1621362600000,
  1621449000000,
  1621535400000,
  1621794600000,
  1621881000000,
  1621967400000,
  1622053800000,
  1622140200000,
  1622399400000,
  1622485800000,
  1622572200000,
  1622658600000,
  1622745000000,
  1623004200000,
  1623090600000,
  1623177000000,
  1623263400000,
  1623349800000,
  1623609000000,
  1623695400000,
  1623781800000,
  1623868200000,
  1623954600000,
  1624213800000,
  1624300200000,
  1624386600000,
  1624473000000,
  1624559400000,
  1624818600000,
  1624905000000,
  1624991400000,
  1625077800000,
  1625164200000,
  1625423400000,
  1625509800000,
  1625596200000,
  1625682600000,
  1625769000000,
  1626028200000,
  1626114600000,
  1626201000000,
  1626287400000,
  1626373800000,
  1626633000000,
  1626719400000,
  1626892200000,
  1626978600000,
  1627237800000,
  1627324200000,
  1627410600000,
  1627497000000,
  1627583400000,
  1627842600000,
  1627929000000,
  1628015400000,
  1628101800000,
  1628188200000,
  1628447400000,
  1628533800000,
  1628620200000,
  1628706600000,
  1628793000000,
  1629052200000,
  1629138600000,
  1629225000000,
  1629397800000,
  1629657000000,
  1629743400000,
  1629829800000,
  1629916200000,
  1630002600000,
  1630261800000,
  1630348200000,
  1630434600000,
  1630521000000,
  1630607400000,
  1630866600000,
  1630953000000,
  1631039400000,
  1631125800000,
  1631471400000,
  1631557800000,
  1631644200000,
  1631730600000,
  1631817000000,
  1632076200000,
  1632162600000,
  1632249000000,
  1632335400000,
  1632421800000,
  1632681000000,
  1632767400000,
  1632853800000,
  1632940200000,
  1633026600000,
  1633285800000,
  1633372200000,
  1633458600000,
  1633545000000,
  1633631400000,
  1633890600000,
  1633977000000,
  1634063400000,
  1634149800000,
  1634495400000,
  1634581800000,
  1634668200000,
  1634754600000,
  1634841000000,
  1635100200000,
  1635186600000,
  1635273000000,
  1635359400000,
  1635445800000,
  1635705000000,
  1635791400000,
  1635877800000,
  1635964200000,
  1636309800000,
  1636396200000,
  1636482600000,
  1636569000000,
  1636655400000,
  1636914600000,
  1637001000000,
  1637087400000,
  1637173800000,
  1637519400000,
  1637605800000,
  1637692200000,
  1637778600000,
  1637865000000,
  1638124200000,
  1638210600000,
  1638297000000,
  1638383400000,
  1638469800000,
  1638729000000,
  1638815400000,
  1638901800000,
  1638988200000,
  1639074600000,
  1639333800000,
  1639420200000,
  1639506600000,
  1639593000000,
  1639679400000,
  1639938600000,
  1640025000000,
  1640111400000,
  1640197800000,
  1640284200000,
  1640543400000,
  1640629800000,
  1640716200000,
  1640802600000,
  1640889000000,
  1641148200000,
  1641234600000,
  1641321000000,
  1641407400000,
  1641493800000,
  1641753000000,
  1641839400000,
  1641925800000,
  1642012200000,
  1642098600000,
  1642357800000,
  1642444200000,
  1642530600000,
  1642617000000,
  1642703400000,
  1642962600000,
  1643049000000,
  1643221800000,
  1643308200000,
  1643567400000,
  1643653800000,
  1643740200000,
  1643826600000,
  1643913000000,
  1644172200000,
  1644258600000,
  1644345000000,
  1644431400000,
  1644517800000,
  1644777000000,
  1644863400000,
  1644949800000,
  1645036200000,
  1645122600000,
  1645381800000,
  1645468200000,
  1645554600000,
  1645641000000,
  1645727400000,
  1645986600000,
  1646159400000,
  1646245800000,
  1646332200000,
  1646591400000,
  1646677800000,
  1646764200000,
  1646850600000,
  1646937000000,
  1647196200000,
  1647282600000,
  1647369000000,
  1647455400000,
  1647801000000,
  1647887400000,
  1647973800000,
  1648060200000,
  1648146600000,
  1648405800000,
  1648492200000,
  1648578600000,
  1648665000000,
  1648751400000,
  1649010600000,
  1649097000000,
  1649183400000,
  1649269800000,
  1649356200000,
  1649615400000,
  1649701800000,
  1649788200000,
  1650220200000,
  1650306600000,
  1650393000000,
  1650479400000,
  1650565800000,
  1650825000000,
  1650911400000,
  1650997800000,
  1651084200000,
  1651170600000,
  1651429800000,
  1651602600000,
  1651689000000,
  1651775400000,
  1652034600000,
  1652121000000,
  1652207400000,
  1652293800000,
  1652380200000,
  1652639400000,
  1652725800000,
  1652812200000,
  1652898600000,
  1652985000000,
  1653244200000,
  1653330600000,
  1653417000000,
  1653503400000,
  1653589800000,
  1653849000000,
  1653935400000,
  1654021800000,
  1654108200000,
  1654194600000,
  1654453800000,
  1654540200000,
  1654626600000,
  1654713000000,
  1654799400000,
  1655058600000,
  1655145000000,
  1655231400000,
  1655317800000,
  1655404200000,
  1655663400000,
  1655749800000,
  1655836200000,
  1655922600000,
  1656009000000,
  1656268200000,
  1656354600000,
  1656441000000,
  1656527400000,
  1656613800000,
  1656873000000,
  1656959400000,
  1657045800000,
  1657132200000,
  1657218600000,
  1657477800000,
  1657564200000,
  1657650600000,
  1657737000000,
  1657823400000,
  1658082600000,
  1658169000000,
  1658255400000,
  1658341800000,
  1658428200000,
  1658687400000,
  1658773800000,
  1658860200000,
  1658946600000,
  1659033000000,
  1659292200000,
  1659378600000,
  1659465000000,
  1659551400000,
  1659637800000,
  1659897000000,
  1660069800000,
  1660156200000,
  1660242600000,
  1660588200000,
  1660674600000,
  1660761000000,
  1660847400000,
  1661106600000,
  1661193000000,
  1661279400000,
  1661365800000,
  1661452200000,
  1661711400000,
  1661797800000,
  1661970600000,
  1662057000000,
  1662316200000,
  1662402600000,
  1662489000000,
  1662575400000,
  1662661800000,
  1662921000000,
  1663007400000,
  1663093800000,
  1663180200000,
  1663266600000,
  1663525800000,
  1663612200000,
  1663698600000,
  1663785000000,
  1663871400000,
  1664130600000,
  1664217000000,
  1664303400000,
  1664389800000,
]
const results = [
  37.64367816091954,
  43.100511073253834,
  43.01260022909508,
  54.30539609644087,
  46.862634256642174,
  49.570200573065904,
  54.383954154727796,
  60.503720663995416,
  63.26061997703789,
  37.18166383701188,
  43.06192660550459,
  41.695303550973655,
  46.01719197707737,
  35.67383918459796,
  37.0561282932417,
  40.31981724728727,
  41.169724770642205,
  45.5160744500846,
  53.16961736150772,
  60.51428571428571,
  59.48571428571429,
  56.922196796338675,
  59.25507900677201,
  58.252427184466015,
  61.393489434608796,
  64.21232876712328,
  65.98173515981736,
  71.19595732734419,
  74.24673109721432,
  74.27597955706985,
  71.93181818181819,
  76.39123102866779,
  80.87649402390437,
  82.41320432555493,
  82.5,
  85.35754824063564,
  86.56215005599104,
  87.10959681998864,
  88.59250851305335,
  89.17233560090703,
  88.03176403857061,
  89.11222780569514,
  85.47929665343165,
  88.47245883021012,
  91.72804532577904,
  91.9501133786848,
  93.41150195421552,
  94.21768707482994,
  92.04997160704146,
  93.5374149659864,
  94.21768707482994,
  93.12849162011173,
  93.83135257498584,
  92.53393665158372,
  89.63759909399774,
  86.23229461756374,
  86.71875,
  89.12797281993205,
  87.59909399773498,
  86.045197740113,
  87.55656108597285,
  87.69487750556793,
  86.26342566421708,
  85.85172608941708,
  85.57692307692307,
  86.48954211418881,
  88.77153974430239,
  88.22535211267606,
  88.21206993795826,
  86.3021420518602,
  86.05307735742518,
  87.17379233759023,
  87.65501691093573,
  87.80213603147835,
  86.50168728908886,
  87.62654668166479,
  85.42128603104213,
  77.64044943820225,
  80.6070826306914,
  80.77571669477234,
  79.72299168975069,
  77.31611454239192,
  73.62514029180696,
  76.30544637843909,
  77.665544332211,
  79.31605074462217,
  79.34904601571269,
  74.74747474747475,
  70.14005602240896,
  71.49245388485187,
  65.98789212988443,
  50.94866071428571,
  46.51422197434467,
  59.59821428571429,
  57.70949720670391,
  52.63736263736264,
  47.79698828778584,
  44.34540389972145,
  35.20266518600778,
  28.45394736842105,
  34.14769572459744,
  37.80487804878049,
  38.935108153078204,
  41.53248195446974,
  48.14207650273224,
  48.30837493067111,
  49.27857935627081,
  53.2409972299169,
  54.29362880886427,
  56.10687022900763,
  52.32300884955752,
  54.45489762036525,
  57.73480662983425,
  59.006550218340614,
  63.03630363036304,
  67.87479406919276,
  67.06849315068493,
  59.20043811610076,
  48.31704668838219,
  48.74041621029573,
  54.186925985953536,
  58.675424192665574,
  54.102844638949676,
  54.929577464788736,
  53.03444505194095,
  55.96280087527352,
  56.478950246036085,
  57.92349726775956,
  65.47425474254742,
  69.6223316912972,
  66.2472647702407,
  71.9672131147541,
  73.12943746586565,
  74.12209616423556,
  74.70076169749727,
  76.73913043478261,
  76.6050054406964,
  76.10571736785329,
  65.61651276480174,
  55.84556824361066,
  54.04671374253124,
  49.294245385450594,
  42.456896551724135,
  49.374660141381185,
  50.32644178454843,
  42.34527687296417,
  40.84736556219446,
  48.03234501347709,
  51.62866449511401,
  51.059206952743075,
  57.73420479302832,
  60.68743286788399,
  63.22336398053001,
  63.582251082251084,
  60.7027027027027,
  59.48136142625607,
  54.43376068376068,
  52.827140549273025,
  51.26684636118598,
  44.15724286483575,
  29.898558462359855,
  36.40280021540118,
  39.924568965517246,
  43.95486297689414,
  31.38097796883396,
  25.6627783669141,
  27.26784755770263,
  28.73254564983888,
  33.064949006978,
  34.675254965110035,
  32.715722604552674,
  37.9495437466452,
  47.235641438539986,
  52.81501340482574,
  57.15050883770755,
  58.04749340369393,
  56.92883895131086,
  55.3475935828877,
  51.12179487179487,
  40.06410256410257,
  28.887717448603055,
  33.06666666666666,
  37.886872998932766,
  41.458222458754655,
  39.51011714589989,
  42.15223097112861,
  48.64144912093767,
  52.15769845498135,
  52.20627325890484,
  58.979808714133895,
  67.93534932221064,
  68.72340425531915,
  71.54255319148936,
  71.96808510638299,
  73.53567625133121,
  78.48958333333333,
  78.03191489361701,
  79.7872340425532,
  81.26663118680149,
  83.24468085106383,
  84.71138845553821,
  77.04569606801275,
  75.33227006911217,
  73.09941520467837,
  63.51063829787233,
  39.5010395010395,
  46.17428267800213,
  44.52709883103082,
  48.29968119022317,
  50.88265835929388,
  54.48275862068965,
  62.51325556733828,
  60.646186440677965,
  57.01429327686607,
  52.07253886010362,
  45.16129032258064,
  46.85351665785299,
  49.07456372289794,
  38.60391327340032,
  21.842650103519667,
  26.880589163598106,
  30.514705882352942,
  28.083989501312335,
  25.45931758530184,
  19.40993788819876,
  13.724463069669984,
  16.937598321971684,
  7.6155462184873945,
  12.585212375458834,
  16.149068322981368,
  16.073298429319372,
  18.238993710691823,
  16.352201257861633,
  13.64572605561277,
  15.941269008914524,
  21.686746987951807,
  26.16431187859759,
  30.92243186582809,
  32.3559670781893,
  28.698379508625194,
  35.3125,
  42.50780437044745,
  41.27310061601643,
  42.03125,
  40.82163286531461,
  40.8004158004158,
  38.469547110879745,
  34.92307692307692,
  35.63636363636364,
  40.13499480789201,
  41.06029106029106,
  50.44155844155844,
  63.561924257932446,
  73.00103842159918,
  76.99896157840082,
  75.09062661833246,
  78.84117951370926,
  80.1631820499745,
  71.90721649484536,
  73.78990731204944,
  66.10687022900763,
  59.453889747552815,
  59.86604842864502,
  68.6082474226804,
  64.2967542503864,
  51.98372329603256,
  56.597938144329895,
  50.670794633642934,
  51.69927909371782,
  45.595054095826896,
  40.82358922216574,
  28.44650205761317,
  29.048843187660665,
  21.318228630278064,
  18.47715736040609,
  13.357215967246674,
  8.755760368663594,
  6.441717791411043,
  8.788962698007154,
  12.664640324214794,
  17.986714358712312,
  20.286152273888604,
  15.668202764976957,
  21.42126789366053,
  21.493440968718467,
  17.23785166240409,
  12.173913043478262,
  13.840653728294178,
  17.475728155339805,
  23.162134944612287,
  25.4341164453524,
  26.836734693877553,
  30.38167938931298,
  27.203260315843096,
  26.532663316582916,
  24.057084607543324,
  23.649337410805302,
  24.451250638080655,
  22.488526262111165,
  14.781297134238311,
  13.761467889908257,
  15.46707503828484,
  9.637939826619071,
  9.280979092299848,
  6.619859578736209,
  9.511698880976601,
  9.05852417302799,
  11.28622267412303,
  15.392456676860347,
  20.09040683073832,
  22.60204081632653,
  22.65784114052953,
  21.581632653061224,
  21.973550356052897,
  26.217980914113507,
  27.83715012722646,
  31.704834605597966,
  39.21668362156663,
  41.88295165394402,
  46.11528822055138,
  44.62474645030426,
  45.261023821591486,
  41.340782122905026,
  43.58193810248604,
  52.63157894736842,
  56.90355329949238,
  60.792280345352964,
  64.16243654822334,
  66.68362156663275,
  60.250626566416045,
  53.9674465920651,
  54.95175215845607,
  59.0030518819939,
  63.29435688866294,
  69.90485728592888,
  73.47560975609755,
  68.90243902439023,
  67.51269035532995,
  68.74682902080163,
  68.56571714142929,
  65.95852301466869,
  66.61608497723824,
  66.29554655870446,
  67.28179551122194,
  70.9367088607595,
  72.27572225038014,
  70.1417004048583,
  62.16350947158524,
  64.82793522267207,
  69.28535225544856,
  71.42857142857143,
  72.34580384226491,
  67.44532803180915,
  73.9746835443038,
  74.77295660948536,
  73.95254921756688,
  75.57213930348259,
  77.29566094853682,
  79.43548387096774,
  81.07700050327126,
  80.47426841574168,
  82.44047619047619,
  82.58455325593135,
  80.10075566750629,
  78.28715365239294,
  68.59879032258065,
  65.7100445324097,
  70.03027245206862,
  66.29667003027245,
  66.43109540636041,
  55.75176589303733,
  32.90450272142504,
  34.76286579212916,
  33.01314459049545,
  35.28520949015649
]
const intermediate = [
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30,
  30
]
const bottomArray =  [
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10
]
const euphoria =  [
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75,
  75
]

const trendTimes200EMA = [
  1438540200000,
  1439145000000,
  1439749800000,
  1440354600000,
  1440959400000,
  1441564200000,
  1442169000000,
  1442773800000,
  1443378600000,
  1443983400000,
  1444588200000,
  1445193000000,
  1445797800000,
  1446402600000,
  1447007400000,
  1447612200000,
  1448217000000,
  1448821800000,
  1449426600000,
  1450031400000,
  1450636200000,
  1451241000000,
  1451845800000,
  1452450600000,
  1453055400000,
  1453660200000,
  1454265000000,
  1454869800000,
  1455474600000,
  1456079400000,
  1456684200000,
  1457375400000,
  1457893800000,
  1458498600000,
  1459103400000,
  1459708200000,
  1460313000000,
  1460917800000,
  1461522600000,
  1462127400000,
  1462732200000,
  1463337000000,
  1463941800000,
  1464546600000,
  1465151400000,
  1465756200000,
  1466361000000,
  1466965800000,
  1467570600000,
  1468175400000,
  1468780200000,
  1469385000000,
  1469989800000,
  1470594600000,
  1471285800000,
  1471804200000,
  1472409000000,
  1473100200000,
  1473618600000,
  1474223400000,
  1474828200000,
  1475433000000,
  1476037800000,
  1476642600000,
  1477247400000,
  1477765800000,
  1478457000000,
  1479148200000,
  1479666600000,
  1480271400000,
  1480876200000,
  1481481000000,
  1482085800000,
  1482690600000,
  1483295400000,
  1483900200000,
  1484505000000,
  1485109800000,
  1485714600000,
  1486319400000,
  1486924200000,
  1487529000000,
  1488133800000,
  1488738600000,
  1489429800000,
  1489948200000,
  1490553000000,
  1491157800000,
  1491762600000,
  1492367400000,
  1492972200000,
  1493663400000,
  1494181800000,
  1494786600000,
  1495391400000,
  1495996200000,
  1496601000000,
  1497205800000,
  1497810600000,
  1498501800000,
  1499020200000,
  1499625000000,
  1500229800000,
  1500834600000,
  1501439400000,
  1502044200000,
  1502649000000,
  1503253800000,
  1503858600000,
  1504463400000,
  1505068200000,
  1505673000000,
  1506277800000,
  1506969000000,
  1507487400000,
  1508092200000,
  1508697000000,
  1509301800000,
  1509906600000,
  1510511400000,
  1511116200000,
  1511721000000,
  1512325800000,
  1512930600000,
  1513535400000,
  1514226600000,
  1514745000000,
  1515349800000,
  1515954600000,
  1516559400000,
  1517164200000,
  1517769000000,
  1518373800000,
  1518978600000,
  1519583400000,
  1520188200000,
  1520793000000,
  1521397800000,
  1522002600000,
  1522607400000,
  1523212200000,
  1523817000000,
  1524421800000,
  1525026600000,
  1525631400000,
  1526236200000,
  1526841000000,
  1527445800000,
  1528050600000,
  1528655400000,
  1529260200000,
  1529865000000,
  1530469800000,
  1531074600000,
  1531679400000,
  1532284200000,
  1532889000000,
  1533493800000,
  1534098600000,
  1534789800000,
  1535308200000,
  1535913000000,
  1536517800000,
  1537122600000,
  1537727400000,
  1538332200000,
  1538937000000,
  1539541800000,
  1540146600000,
  1540751400000,
  1541356200000,
  1541961000000,
  1542565800000,
  1543170600000,
  1543775400000,
  1544380200000,
  1544985000000,
  1545589800000,
  1546194600000,
  1546799400000,
  1547404200000,
  1548009000000,
  1548613800000,
  1549218600000,
  1549823400000,
  1550428200000,
  1551033000000,
  1551724200000,
  1552242600000,
  1552847400000,
  1553452200000,
  1554057000000,
  1554661800000,
  1555266600000,
  1555871400000,
  1556562600000,
  1557081000000,
  1557685800000,
  1558290600000,
  1558895400000,
  1559500200000,
  1560105000000,
  1560709800000,
  1561314600000,
  1561919400000,
  1562524200000,
  1563129000000,
  1563733800000,
  1564338600000,
  1564943400000,
  1565634600000,
  1566153000000,
  1566757800000,
  1567449000000,
  1567967400000,
  1568572200000,
  1569177000000,
  1569781800000,
  1570386600000,
  1570991400000,
  1571682600000,
  1572114600000,
  1572805800000,
  1573410600000,
  1574015400000,
  1574620200000,
  1575225000000,
  1575829800000,
  1576434600000,
  1577039400000,
  1577644200000,
  1578249000000,
  1578853800000,
  1579458600000,
  1580063400000,
  1580668200000,
  1581273000000,
  1581877800000,
  1582482600000,
  1583087400000,
  1583692200000,
  1584297000000,
  1584901800000,
  1585506600000,
  1586197800000,
  1586716200000,
  1587321000000,
  1587925800000,
  1588530600000,
  1589135400000,
  1589740200000,
  1590431400000,
  1590949800000,
  1591554600000,
  1592159400000,
  1592764200000,
  1593369000000,
  1593973800000,
  1594578600000,
  1595183400000,
  1595788200000,
  1596393000000,
  1596997800000,
  1597602600000,
  1598207400000,
  1598812200000,
  1599417000000,
  1600021800000,
  1600626600000,
  1601231400000,
  1601836200000,
  1602441000000,
  1603045800000,
  1603650600000,
  1604255400000,
  1604860200000,
  1605551400000,
  1606069800000,
  1606761000000,
  1607279400000,
  1607884200000,
  1608489000000,
  1609093800000,
  1609698600000,
  1610303400000,
  1610908200000,
  1611513000000,
  1612117800000,
  1612722600000,
  1613327400000,
  1613932200000,
  1614537000000,
  1615141800000,
  1615746600000,
  1616351400000,
  1617042600000,
  1617561000000,
  1618165800000,
  1618770600000,
  1619375400000,
  1619980200000,
  1620585000000,
  1621189800000,
  1621794600000,
  1622399400000,
  1623004200000,
  1623609000000,
  1624213800000,
  1624818600000,
  1625423400000,
  1626028200000,
  1626633000000,
  1627237800000,
  1627842600000,
  1628447400000,
  1629052200000,
  1629657000000,
  1630261800000,
  1630866600000,
  1631471400000,
  1632076200000,
  1632681000000,
  1633285800000,
  1633890600000,
  1634495400000,
  1635100200000,
  1635705000000,
  1636309800000,
  1636914600000,
  1637519400000,
  1638124200000,
  1638729000000,
  1639333800000,
  1639938600000,
  1640543400000,
  1641148200000,
  1641753000000,
  1642357800000,
  1642962600000,
  1643567400000,
  1644172200000,
  1644777000000,
  1645381800000,
  1645986600000,
  1646591400000,
  1647196200000,
  1647801000000,
  1648405800000,
  1649010600000,
  1649615400000,
  1650220200000,
  1650825000000,
  1651429800000,
  1652034600000,
  1652639400000,
  1653244200000,
  1653849000000,
  1654453800000,
  1655058600000,
  1655663400000,
  1656268200000,
  1656873000000,
  1657477800000,
  1658082600000,
  1658687400000,
  1659292200000,
  1659897000000,
  1660588200000,
  1661106600000,
  1661711400000,
  1662316200000,
  1662921000000,
  1663525800000,
  1664130600000,
  1664735400000
]
const results200EMA = [
  73.25301204819277,
  59.518072289156635,
  54.274193548387096,
  34.627831715210355,
  23.763179237631793,
  25.751421608448418,
  30.273752012882447,
  34.27876823338736,
  37.24859211584876,
  55.04,
  64.06752411575563,
  65.44293695131684,
  53.28525641025641,
  43.73996789727127,
  44.83037156704362,
  53.05798252581414,
  62.96296296296296,
  64.53900709219859,
  50.82872928176796,
  63.42042755344418,
  72.24394057857701,
  76.98907956318253,
  67.1862821512081,
  37.315748642358415,
  29.6411856474259,
  39.00543900543901,
  28.738317757009348,
  9.90566037735849,
  13.70399373531715,
  9.594383775351014,
  24.453125,
  28.328173374613,
  30.67389620449264,
  37.27901614142967,
  43.53846153846154,
  49.264136328427576,
  64.61538461538461,
  67.87086856264412,
  63.17411402157165,
  54.77657935285054,
  59.61389961389961,
  54.217791411042946,
  56.13496932515337,
  56.891271056661566,
  61.7624521072797,
  66.36085626911316,
  59.6958174904943,
  77.77777777777779,
  80.94879518072288,
  78.05059523809523,
  78.70439314966492,
  77.62081784386618,
  72.80832095096582,
  64.54005934718101,
  66.71619613670133,
  65.31065088757396,
  64.43949517446177,
  69.06686260102866,
  65.43846720707442,
  70.57522123893806,
  57.363770250368184,
  71.75182481751825,
  69.27578639356254,
  77.44525547445255,
  76.47487254187911,
  59.73451327433629,
  44.42013129102845,
  23.97959183673469,
  31.432748538011694,
  35.14887436456064,
  47.18772826880935,
  39.76608187134503,
  30.007283321194468,
  36.991279069767444,
  57.17407137654771,
  64.75707034082669,
  64.30107526881721,
  71.91091954022988,
  76.33642195295795,
  76.521116678597,
  64.83594864479315,
  67.0958512160229,
  64.87839771101574,
  60.042887776983555,
  68.64285714285714,
  67.66381766381767,
  70.37037037037037,
  80.5693950177936,
  80.96249115357395,
  80.7773851590106,
  79.39308398023994,
  75.15833919774806,
  75.15878616796047,
  68.44694307800422,
  60.32417195207893,
  58.99788285109386,
  59.95777621393385,
  60.87570621468926,
  54.23131170662906,
  52.213633169360506,
  64.92589978828511,
  66.69039145907473,
  65.70827489481066,
  62.37762237762238,
  54.513888888888886,
  31.843575418994412,
  44.303797468354425,
  42.88732394366197,
  56.87103594080338,
  60.4050279329609,
  61.37640449438202,
  54.86354093771868,
  48.812849162011176,
  58.32177531206657,
  61.91799861014593,
  63.76210235131396,
  68.73706004140787,
  76.49896623018608,
  68.10996563573883,
  64.16264645072364,
  71.55586017820424,
  70.5521472392638,
  69.33607118412046,
  67.53424657534246,
  80.79561042524006,
  84.9762066621346,
  88.51351351351352,
  89.44519621109607,
  76.65764546684709,
  69.90489130434783,
  37.5,
  43.93220338983051,
  40.67567567567568,
  36.59198913781398,
  36.41891891891892,
  21.539500337609724,
  25.423728813559322,
  14.912280701754385,
  20.053835800807537,
  39.95943204868154,
  42.513368983957214,
  46.37873754152824,
  45.733333333333334,
  37.850467289719624,
  34.0878828229028,
  26.382411725516324,
  23.68245496997999,
  23.51765489673551,
  23.066666666666666,
  25.083166999334665,
  19.307589880159785,
  14.866666666666667,
  15.936254980079681,
  18.807947019867548,
  14.871116986120292,
  23.556735235567352,
  32.87310979618672,
  31.92890059249506,
  30.500658761528328,
  71.42857142857143,
  40.30243261012492,
  38.179436804191226,
  36.19672131147541,
  23.931623931623932,
  10.526315789473683,
  7.180500658761528,
  10.869565217391305,
  11.26391617550753,
  9.102815979043877,
  19.829284307288248,
  24.81800132362674,
  23.333333333333332,
  21.218074656188605,
  24.868766404199473,
  19.58087753765553,
  28.93869479235333,
  32.04456094364351,
  33.94736842105263,
  31.901041666666668,
  33.85518590998043,
  33.33333333333333,
  22.033898305084744,
  20.79790712884238,
  17.024041585445094,
  12.418725617685306,
  16.112198303979124,
  26.08978529603123,
  44.66019417475729,
  50.87265675500969,
  43.878865979381445,
  46.253229974160206,
  50.80593165699548,
  49.51456310679612,
  48.324742268041234,
  39.65183752417795,
  31.870967741935484,
  21.553398058252426,
  20.025756600128783,
  38.55035279025016,
  44.90057729313663,
  38.27874116891458,
  30.275817831943552,
  25.78374920025592,
  30.92317624273725,
  28.37060702875399,
  22.37851662404092,
  15.295629820051415,
  13.700384122919335,
  9.630102040816327,
  13.61323155216285,
  13.511790949649457,
  10.549589387239418,
  14.22278162366268,
  17.13925645872716,
  29.874213836477985,
  34.17085427135678,
  37.08567854909318,
  23.29367564182843,
  23.226616446955433,
  32.288401253918494,
  31.962616822429908,
  47.37851662404092,
  43.194530764449965,
  37.35239279055314,
  38.20784069695084,
  41.795665634674926,
  34.07270486752927,
  32.96158612143743,
  36.26237623762376,
  42.680667078443484,
  57.57575757575758,
  59.4694632942628,
  72.14022140221402,
  68.05896805896806,
  43.374233128834355,
  52.8290282902829,
  43.627450980392155,
  40.220723482526054,
  21.0913549969344,
  16.941896024464832,
  7.46177370030581,
  3.0116779348494163,
  2.8125,
  3.4355828220858897,
  9.45945945945946,
  16.65642286416718,
  16.941896024464832,
  21.677893447642376,
  16.390423572744016,
  18.684695759065765,
  18.432333129210043,
  24.58614347026364,
  56.01710445937691,
  56.014580801944106,
  68.6010995723885,
  77.85888077858881,
  74.61866992068335,
  75.19708914493633,
  67.09245742092457,
  66.82838083687082,
  56.17772367620207,
  69.40389294403893,
  77.99879445449066,
  88.3524441762221,
  91.39590854392299,
  80.33674082982562,
  72.27901383042695,
  74.75961538461539,
  52.19219219219219,
  62.46246246246246,
  61.134328358208954,
  52.431791221826806,
  60.64209274673008,
  51.513353115727,
  59.38425103611604,
  69.53447259870359,
  74.86818980667839,
  81.8075117370892,
  89.38416422287389,
  92.86966686148452,
  93.98364485981308,
  91.84149184149184,
  94.89262913522926,
  95.2463768115942,
  92.63341067285383,
  85.44819557625145,
  76.07433217189315,
  82.95520651541594,
  81.43435511856565,
  77.25173210161664,
  75.99768652400232,
  81.2929061784897,
  79.01023890784982,
  66.51480637813212,
  57.630979498861045,
  67.12095400340715,
  72.07461842849068,
  57.72495755517827,
  54.92638731596829,
  66.38465877044557,
  73.08126410835214,
  76.3615946097698,
  85.94716132658797,
  89.41769316909294,
  92.79731993299832,
  95.08654383026243,
  90.94972067039106,
  91.57366071428571,
  90.92427616926503,
  92.10672595886604,
  92.22654081066074,
  89.30155210643017,
  86.26038781163436,
  83.45284059569774,
  74.57347275729224,
  56.043956043956044,
  60.635964912280706,
  69.07103825136612,
  70.28353326063251,
  71.4519650655022,
  67.86102062975027,
  69.60996749729144,
  78.42818428184282,
  81.36142625607779,
  63.484358144552324,
  55.603448275862064,
  66.79245283018868,
  67.7765843179377,
  56.03632478632478,
  45.80886278697277,
  46.76564156945917,
  61.619904711487564,
  49.02374670184697,
  46.65260938323669,
  63.20209973753281,
  72.78415015641293,
  79.6875,
  69.21476859074363,
  57.06860706860707,
  64.01869158878505,
  51.917098445595855,
  37.577639751552795,
  20.755693581780537,
  22.51552795031056,
  34.60350154479917,
  41.615226337448554,
  38.860369609856264,
  47.07692307692308,
  68.67963152507677,
  65.17083120856707,
  59.64376590330789,
  46.23601220752798,
  27.30045754956787,
  14.060913705583754,
  24.51874366767984,
  18.51664984863774,
  24.823766364551865,
  22.261306532663315,
  11.060834590246355,
  13.891675025075227,
  19.085886489201407,
  28.578603716725265,
  31.779448621553886,
  47.418546365914786,
  48.62155388471178,
  55.53329994992489,
  56.7216391804098,
  62.19451371571072,
  64.85543369890328,
  67.19681908548708,
  74.37810945273633,
  68.00595238095238,
  59.9208312716477,
  50.569025235032164,
  45.552297165200386
]
const goodMarket =  [
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50
]
const bottom =  [
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10,
  10
]

const MarketBreadthAtlas = () => {
  const [prepData, setPrepData] = useState([])
  const [prep200EMAData, setPrep200EMAData] = useState([])
  const [prepData1, setPrepData1] = useState([])
  const [prep200EMAData1, setPrep200EMAData1] = useState([])

  const dataKeys50EMA = [{key: "intermediate", display: "intermediate", color:"red"},
    {key: "bottom", display: "bottom", color:"blue"},
    {key: "euphoria", display: "euphoria", color:"green"}]
  const dataKeys200EMA = [{key: "goodMarket", display: "good market", color:"red"},
    {key: "bottom", display: "bottom", color:"blue"}]

  const processWidgetResponse = (response) => {
    const data = JSON.parse(response);
    const obj = {}
    obj['trendTime'] = data?.metaData?.[0]?.tradeTimes
    data?.groupData?.[0]?.results?.forEach(r => {
      const e = Object.entries(r)
      const k = e[0]?.[0] === '%' ? 'result' :e[0]?.[0]
      obj[k] = e[0]?.[1]
    })
    return obj
  }

  const reformatWidgetResponse = (response) => {
    const trendTimes = response.trendTime
    const cols = Object.keys(response)
    const formattedData = []

    trendTimes.forEach((element, index) => {
      const obj = {};
      cols.forEach(c => {
        if (c === 'trendTime') {
          obj[c] = response[c][index] / 1000
        }
        else {
          obj[c] = response[c][index]
        }
      })
      formattedData.push(obj)
    });
    return formattedData
  }

  useEffect(() => {
    setPrepData1(reformatWidgetResponse(processWidgetResponse(widgetResponse50EMA())))
    setPrep200EMAData1(reformatWidgetResponse(processWidgetResponse(widgetResponse200EMA())))
  }, [])

  useEffect(() => {
    trendTimes.forEach((element, index) => {
      const obj = {};
      obj['trendTime'] = trendTimes[index] / 1000;
      obj['result'] = results[index];
      obj['intermediate'] = intermediate[index];
      obj['bottom'] = bottomArray[index];
      obj['euphoria'] = euphoria[index];
      prepData.push(obj)
    });
    setPrepData(prepData)

    trendTimes200EMA.forEach((element, index) => {
      const obj = {};
      obj['trendTime'] = element / 1000;
      obj['result'] = results200EMA[index];
      obj['goodMarket'] = goodMarket[index];
      obj['bottom'] = bottom[index];
      prep200EMAData.push(obj)
    });
    console.log('prep200EMAData', prep200EMAData)
    setPrep200EMAData(prep200EMAData)

  }, [])

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h4" gutterBottom component="div">
          Atlas Dashboard
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <AtlasChart header='% Stocks above 50 EMA' initialData={prepData} dataKeys={dataKeys50EMA} prepData={prepData1} yLegend={"%"}/>
        <AtlasChart header='% Stocks above 200 EMA' initialData={prep200EMAData} dataKeys={dataKeys200EMA} prepData={prep200EMAData1} yLegend={"%"}/>
      </Grid>
    </>
  )
}

export default MarketBreadthAtlas;